import { AppModal, Box, Flex, Text } from '../ui';
import BagIcon from '../ui/BagIcon';

// Approved A2 slips (S13/C21). modalPort.test checks these written totals
// against calculateRoundScore; this component never duplicates scoring math.
const slips = [
  {
    title: 'Takes Bags',
    desc: 'Nil’s tricks become bags. Partner is scored on their own tricks.',
    partner: 'Partner missed their bid of 5',
    partnerDetail: 'Made 4 of 5. Nil’s tricks don’t help.',
    partnerPoints: '−50',
    bagsLabel: '2 bags',
    bagsDetail: 'Nil’s 2 tricks become bags, +1 point each',
    bagPoints: '+2',
    total: '−148',
    bags: 2,
  },
  {
    title: 'Helps Team Bid',
    desc: 'Nil’s tricks count toward partner’s bid. Any extra become bags.',
    partner: 'Partner made their bid of 5',
    partnerDetail: 'Partner’s 4 tricks + Nil’s 1st trick = 5',
    partnerPoints: '+50',
    bagsLabel: '1 bag',
    bagsDetail: 'Nil’s 2nd trick is extra, +1 point',
    bagPoints: '+1',
    total: '−49',
    bags: 1,
  },
  {
    title: 'No Bags / No Help',
    desc: 'Nil’s tricks are ignored. Partner is scored on their own tricks.',
    partner: 'Partner missed their bid of 5',
    partnerDetail: 'Made 4 of 5. Nil’s tricks don’t help.',
    partnerPoints: '−50',
    bagsLabel: 'No bags',
    bagsDetail: 'Nil’s 2 tricks are ignored',
    bagPoints: '0',
    total: '−150',
    bags: 0,
  },
];

export const ScoreSettingsContent = () => (
  <Box className="nil-help-content">
    {slips.map((slip, index) => (
      <section
        key={slip.title}
        className="nil-help-rule"
        data-rule={['takesBags', 'helpsTeamBid', 'noBagsNoHelp'][index]}
      >
        <Text
          as="h3"
          fontSize="var(--spades-font-size-lg)"
          fontWeight="700"
          lineHeight={1.25}
        >
          {slip.title}
        </Text>
        <Text
          color="spades.muted"
          fontSize="var(--spades-font-size-sm)"
          lineHeight={1.25}
        >
          {slip.desc}
        </Text>
        <Box className="nil-score-slip" data-testid="nil-score-slip">
          <div className="nil-slip-hand">
            <span className="setting-label">EXAMPLE</span>
            <span>
              <span className="nil-emphasis">Nil made 2 tricks</span> · Partner
              bid 5, made 4
            </span>
          </div>
          <div className="nil-slip-line">
            <div>
              Nil failed
              <small>
                Made <span className="nil-emphasis">2 tricks</span> instead of 0
              </small>
            </div>
            <strong className="nil-negative">−100</strong>
          </div>
          <div className="nil-slip-line">
            <div>
              {slip.partner}
              <small>{slip.partnerDetail}</small>
            </div>
            <strong
              className={
                slip.partnerPoints.startsWith('−')
                  ? 'nil-negative'
                  : 'nil-positive'
              }
            >
              {slip.partnerPoints}
            </strong>
          </div>
          <div className="nil-slip-line">
            <div>
              {slip.bagsLabel}
              <small>{slip.bagsDetail}</small>
            </div>
            <strong>{slip.bagPoints}</strong>
          </div>
          <Flex className="nil-slip-total">
            <span className="setting-label">ROUND TOTAL</span>
            <strong className="nil-negative" data-testid="slip-total">
              {slip.total}
            </strong>
            <Flex
              align="center"
              gap="var(--spades-spacing-xs)"
              data-testid="slip-bags"
            >
              <BagIcon team="team1" />
              {slip.bags}
            </Flex>
          </Flex>
        </Box>
      </section>
    ))}
  </Box>
);

interface ScoreSettingsModalProps {
  isOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
}
function ScoreSettingsModal({
  isOpen,
  setIsModalOpen,
}: ScoreSettingsModalProps) {
  return (
    <AppModal
      analyticsId="score_help"
      isOpen={isOpen}
      onClose={setIsModalOpen}
      title="Score Settings"
    >
      <ScoreSettingsContent />
    </AppModal>
  );
}
export default ScoreSettingsModal;
